<template>
  <div class="animated fadeIn">

    <!-- Main area -->
    <b-card>

      <b-row class="mb-4">
        <b-col sm="2">
          <h4 id="channel-details" class="card-title mb-0">Detailed Channel View</h4>
          <div class="small text-muted">{{ periodStartDay }} - {{ currentDay }}</div>
        </b-col>
        <b-col sm="3">
          <v-select 
          label="name" 
          :options="sortedTeamChannels"
          :value="selectedChannel"
          :searchable="true"
          :close-on-select="true"
          ref="channelSelector"
          @input="channelSelected">
            <template slot="option" slot-scope="option">
              #{{ option.name }}
            </template>
          </v-select>
        </b-col>

      </b-row>

      <template v-if="detailDataLoaded && selectedChannel !== null">
        <template v-if="topCommunicatorsByMessagesTableData.length > 0">
          <!-- Top Row -->
          <div class="card-deck mb-3">
            <!-- Top Communicators - Messages -->
            <b-card :no-body="true">
              <b-card-body class="p-3 clearfix">

                <div class="text-muted text-uppercase font-weight-bold font-s">Top Communicators</div>

                <b-table class="mb-0 table-striped" responsive="sm" hover :items="topCommunicatorsByMessagesTableData" :fields="topCommunicatorsByMessagesFields" head-variant="light">

                  <div slot="avatar" class="avatar" slot-scope="item">
                    <img :src="item.value.url" class="img-avatar" alt="">
                  </div>

                  <div slot="teammate" slot-scope="item">
                    <div>
                      <router-link :to="'/details/teammate?uid=' + item.item.slackId" class="unstyled-link">
                        {{item.value}}
                      </router-link>
                    </div>
                  </div>

                  <div slot="messages" slot-scope="item">
                    <div class="clearfix">
                      <div class="float-left">
                        <strong>{{item.value}}</strong>
                      </div>

                    </div>
                    <b-progress height={} class="progress-xs" v-model="item.value" :max="topCommunicatorByMessagesMax"></b-progress>
                  </div>

                </b-table>

              </b-card-body>
            </b-card>

            <!-- Most Mentioned -->
            <b-card :no-body="true">
              <b-card-body class="p-3 clearfix">

                <div class="text-muted text-uppercase font-weight-bold font-s">Most Mentioned</div>

                <b-table class="mb-0 table-striped" responsive="sm" hover :items="topMentioned" :fields="topMentionedFields" head-variant="light">

                  <div slot="avatar" class="avatar" slot-scope="item">
                    <img :src="item.value.url" class="img-avatar" alt="">
                    
                  </div>
                  <div slot="teammate" slot-scope="item">
                    <div>
                      <router-link :to="'/details/teammate?uid=' + item.item.slackId" class="unstyled-link">
                        {{item.value}}
                      </router-link>
                    </div>
                  </div>
                  <div slot="mentions" slot-scope="item">
                    <div class="clearfix">
                      <div class="float-left">
                        <strong>{{item.value}}</strong>
                      </div>
                    </div>
                    <b-progress height={} class="progress-xs" v-model="item.value" :max="topMentionedMostMentions"></b-progress>
                  </div>

                </b-table>

              </b-card-body>
            </b-card>

            <!-- Information Seekers (mentioners) -->
            <b-card :no-body="true">
              <b-card-body class="p-3 clearfix">

                <div class="text-muted text-uppercase font-weight-bold font-s">Top Information Seekers</div>

                <b-table class="mb-0 table-striped" responsive="sm" hover :items="topMentioners" :fields="topMentionersFields" head-variant="light">

                  <div slot="avatar" class="avatar" slot-scope="item">
                    <img :src="item.value.url" class="img-avatar" alt="">
                    
                  </div>
                  <div slot="teammate" slot-scope="item">
                    <div>
                      <router-link :to="'/details/teammate?uid=' + item.item.slackId" class="unstyled-link">
                        {{item.value}}
                      </router-link>
                    </div>
                  </div>
                  <div slot="mentions" slot-scope="item">
                    <div class="clearfix">
                      <div class="float-left">
                        <strong>{{item.value}}</strong>
                      </div>
                    </div>
                    <b-progress height={} class="progress-xs" v-model="item.value" :max="topMentionersMostMentions"></b-progress>
                  </div>

                </b-table>


              </b-card-body>
            </b-card>


          </div>

          <!-- Main Chart Area -->
          <h4 id="message-activity" class="card-title mb-2 mt-4">#{{ selectedChannel.name }} Message Activity</h4>
          <channel-message-activity-chart
          :chart-data="detailData.message_counts"
          :user-data="teammates"
          class="chart-wrapper" 
          style="height:360px" 
          height="360" />

          <!-- Key Phrases -->
          <div class="card-deck mt-4 mb-3">
            <b-card :no-body="true">
              <b-card-body class="p-3 clearfix">
                <div class="text-muted text-uppercase font-weight-bold font-s mb-2">
                  Key Phrases - Selected Period
                </div>

                <grams-table :grams="topGrams"></grams-table>

              </b-card-body>
            </b-card>

            <b-card :no-body="true">
              <b-card-body class="p-3 clearfix">
                <div class="text-muted text-uppercase font-weight-bold font-s mb-2">
                  Key Phrases - Trending
                </div>

                <grams-table :grams="trendingGrams"></grams-table>      

              </b-card-body>
            </b-card>
          </div>
        </template>
        <template v-else>
          <p>
            This channel has not seen any activity in the selected time window.  Try expanding the time window, or check back later!
          </p>
        </template>
        

      </template>
      <template v-else-if="selectedChannel !== null && !detailDataLoaded">
      <div class="sk-folding-cube align-middle">
        <div class="sk-cube1 sk-cube"></div>
        <div class="sk-cube2 sk-cube"></div>
        <div class="sk-cube4 sk-cube"></div>
        <div class="sk-cube3 sk-cube"></div>
      </div>
    </template>

      
    </b-card>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { getStyle } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import GramsTable from './common/GramsTable.vue'
import ChannelMessageActivityChart from './detail/ChannelMessageActivityChart'

export default {
  name: 'ChannelDetailDashboard',
  components: {
    GramsTable,
    ChannelMessageActivityChart
  },
  data: function () {
    return {
      pageName: 'channeldetail',
      currentDay: moment().format('MMMM Do'),

      periodSelected: 'Day',
      periodStartDay: moment().subtract(7, 'd').format('MMMM Do'),

      selectedChannel: null,

      topCommunicatorsByMessagesFields: {
        avatar: {
          label: '', //'<i class="icon-people"></i>',
          class: 'text-center'
        },
        teammate: {
          label: 'Teammate'
        },
        messages: {
          label: '# Messages'
        }
      },
      topMentionedFields: {
        avatar: {
          label: '', //'<i class="icon-people"></i>',
          class: 'text-center'
        },
        teammate: {
          label: 'Teammate'
        },
        mentions: {
          label: '# Mentions'
        }
      },
      topMentionersFields: {
        avatar: {
          label: '', //'<i class="icon-people"></i>',
          class: 'text-center'
        },
        teammate: {
          label: 'Teammate'
        },
        mentions: {
          label: '# of @s'
        }
      },
    }
    
  },

  watch: {
    timePeriod: function(period, lastPeriod) {
      if(this.$store.getters.currentPage === this.pageName) {
        this.fetchDetailData(period)
      }
    },
    filterUserIds: function(userIds, lastUserIds) {
      if(this.$store.getters.currentPage === this.pageName && this.selectedChannel !== null) {
        this.fetchDetailData(this.timePeriod)
      }
    },

    uriChannel: function(uriChannel, lastUriChannel) {
      if(uriChannel) {
        this.$store.commit('channelDetailDataLoaded', false)
        this.selectedChannel = uriChannel
      }
    },
  },

  computed: {
    timePeriod() {
      let p = this.$store.getters.timePeriod
      return p
    },
    filterUserIds() {
      return this.$store.getters.filterUserIds
    },
    teammates() {
      return this.$store.getters.teamMembers
    },
    teamChannels() {
      return this.$store.getters.teamChannels
    },
    sortedTeamChannels() {
      return this.teamChannels.sort((a, b) => a.name > b.name);
    },

    detailData() {
      return this.$store.getters.channelDetailData
    },
    detailDataLoaded() {
      return this.$store.getters.channelDetailDataLoaded
    },

    uriChannel() {
      if('cid' in this.$route.query) {
        let cid = this.$route.query.cid
        let channel = this.$store.getters.teamChannelBySlackId(cid)
        if(typeof channel == 'undefined') {
          return false
        }
        return channel
      } else {
        return false
      }
    },

    userMessageTotals() {
      let d = this.detailData.message_counts
      let userTotals = {}
      Object.keys(d).forEach(function(uid, userIndex) {
        if(!(uid in userTotals)) {
          userTotals[uid] = 0
        }
        let userData = d[uid]
        // console.log(userData)
        Object.keys(userData).forEach(function(epoch, epochIndex) {
          userTotals[uid] += userData[epoch].messages
        })
      })

      return userTotals
    },

    topCommunicatorByMessagesMax() {
      let totals = this.userMessageTotals
      if(Object.keys(totals).length > 0) {
        let topUser = Object.keys(totals).sort(function(a, b) { 
          return totals[b] - totals[a]
        }).slice(0, 1)
        return totals[topUser]
      }
      return 100
    },
    topCommunicatorsByMessagesTableData() {
      let totals = this.userMessageTotals
      let formattedCommunicators = []
      // console.log(totals)
      let sortedUids = Object.keys(totals).sort(function(a, b) { 
        return totals[b] - totals[a]
      }).slice(0, 5)  // top 5

      // console.log(sortedUids)
      for(const uid of sortedUids) {
        let user = this.teammates.find(member => member.id == uid)

        formattedCommunicators.push({
          avatar: {url: user.avatar},
          teammate: user.real_name,
          slackId: user.slack_id,
          messages: totals[uid]
        })
      }
      return formattedCommunicators
    },

    topMentionedMostMentions() {
      let mentioned = this.detailData.top_mentioned
      if(mentioned.length > 0) {
        return mentioned[0].mentions
      }
      return 100
    },
    topMentioned() {
      let mentioned = this.detailData.top_mentioned
      let formattedMentioned = []
      for (const m of mentioned) {
        let user = this.teammates.find(member => member.id == m.user_id)
        let status = ''
        formattedMentioned.push({
          avatar: {url: user.avatar, status: status},
          teammate: user.real_name,
          slackId: user.slack_id,
          mentions: m.mentions
        })
      }
      return formattedMentioned
    },

    topMentionersMostMentions() {
      let mentioners = this.detailData.top_mentioners
      if(mentioners.length > 0) {
        return mentioners[0].mentions
      }
      return 100
    },
    topMentioners() {
      let mentioned = this.detailData.top_mentioners
      let formattedMentioners = []
      for (const m of mentioned) {
        let user = this.teammates.find(member => member.id == m.user_id)
        let status = ''
        formattedMentioners.push({
          avatar: {url: user.avatar, status: status},
          teammate: user.real_name,
          slackId: user.slack_id,
          mentions: m.mentions
        })
      }
      return formattedMentioners
    },

    topGrams() {
      return this.detailData.top_grams
    },
    trendingGrams() {
      return this.detailData.trending_grams
    },
  },
  
  methods: {
    channelSelected(value) {
      this.selectedChannel = value

      if(value !== null) {
        this.fetchDetailData(this.timePeriod)
      }
    },

    fetchDetailData: function(period) {
      this.$store.dispatch('updateChannelDetailData', [period, this.selectedChannel.id, this.filterUserIds])

      if(period == '6h') {
        this.periodStartDay = moment().subtract(6, 'h').format('MMMM Do')
      } else if(period == '12h') {
        this.periodStartDay = moment().subtract(12, 'h').format('MMMM Do')
      } else if(period == 'Day') {
        this.periodStartDay = moment().subtract(1, 'd').format('MMMM Do')
      } else if(period == 'Week') {
        this.periodStartDay = moment().subtract(7, 'd').format('MMMM Do')
      } else if(period == '2Weeks') {
        this.periodStartDay = moment().subtract(14, 'd').format('MMMM Do')
      } else if(period == 'Month') {
        this.periodStartDay = moment().subtract(30, 'd').format('MMMM Do')
      }
    }
  },

  mounted() {
    this.$store.commit('currentPage', this.pageName)
    this.$store.commit('channelDetailDataLoaded', false)

    // CNC2A6718 - unum_agent
    let channelFromUri = this.uriChannel
    if(channelFromUri) {
      // console.log(channelFromUri)
      // this triggers the @input event on the vue-select object
      this.selectedChannel = channelFromUri
    }
    
  },

  beforeDestroy() {
    this.$store.commit('channelDetailDataLoaded', false)
  }
}
</script>
